// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-file__container[data-v-0babfbc6],.v-file input[data-v-0babfbc6]{position:relative}.v-file__error[data-v-0babfbc6]{display:flex;align-items:flex-start;margin-top:4px;background:none;color:var(--clr-text);font-size:14px;font-family:Roboto;font-style:normal;font-weight:700;line-height:20px}.v-file__error .v-icon[data-v-0babfbc6]{--icon-size:20px;margin-right:8px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
